import React from 'react'
import { Heading } from '@pandiafi/design-system'
import { useTranslation } from 'react-i18next'

import {
  ContractModificationRequest,
  ContractTenant,
} from '../../../../common/validations'
import { getTenantName } from '../../../utils/getTenantName'

import { Section, TextTable } from 'components'
import { renderDate } from 'utils'

type PreviewData = Omit<ContractModificationRequest, 'id'>

interface ContractModificationRequestPreviewProps {
  contractModificationRequest: PreviewData
  tenants: ContractTenant[]
}

export const ContractModificationRequestPreview: React.FC<
  ContractModificationRequestPreviewProps
> = ({ contractModificationRequest, tenants }) => {
  const { t } = useTranslation(['common', 'contractModification'])

  const { inEffect, description, removeTenantEvents, transferTenantEvent } =
    contractModificationRequest

  const terminatedTenants = tenants.filter((tenant) =>
    removeTenantEvents.some(
      (removeTenant) => removeTenant.removeTenantId === tenant.id
    )
  )

  const newContractParty = tenants.find(
    (tenant) => tenant.id === transferTenantEvent?.destinationTenantId
  )

  return (
    <>
      <div className="bg-brand-1 py-8 rounded-t-lg -mt-7 -mx-7 mb-10 text-center">
        <Heading size="l" element="h2">
          {t('contractModification:headings.modificationPreview')}
        </Heading>
      </div>
      <Section className="mb-12">
        {terminatedTenants.map((tenant, index) => (
          <TextTable.Row key={tenant.id}>
            <TextTable.Cell>
              {index === 0
                ? t('contractModification:labels.movingOutTenant')
                : ''}
            </TextTable.Cell>
            <TextTable.Cell>{getTenantName(tenant)}</TextTable.Cell>
          </TextTable.Row>
        ))}
        <TextTable.Row>
          <TextTable.Cell>
            {t('contractModification:labels.movingOutDate')}
          </TextTable.Cell>
          <TextTable.Cell>{renderDate(inEffect)}</TextTable.Cell>
        </TextTable.Row>
        {description && (
          <TextTable.Row>
            <TextTable.Cell>
              {t('contractModification:labels.modificationDescription')}
            </TextTable.Cell>
            <TextTable.Cell>{description}</TextTable.Cell>
          </TextTable.Row>
        )}
        {newContractParty && (
          <TextTable.Row>
            <TextTable.Cell>
              {t('contractModification:labels.newContractParty')}
            </TextTable.Cell>
            <TextTable.Cell>{getTenantName(newContractParty)}</TextTable.Cell>
          </TextTable.Row>
        )}
      </Section>
    </>
  )
}
